import type { MantleMode } from '~/types/leData';

export function asMantleMode(value: unknown): MantleMode | null {
  return value === 'light' || value === 'standard' || value === 'extended' || value === 'ultra' ? value : null;
}
